import React, { useEffect, useState } from "react";
import { Customer } from "@/api/customers";
import RigthPanel from "@/ui-controls/RigthPanel";
import DeleteCustomerForm from "@/components/customers/DeleteCustomerForm";

interface Props {
  customer: Customer | undefined;
  onDelete: (customer: Customer) => any;
  onClose: () => any;
}

const DeleteCustomer = (props: Props) => {
  useEffect(() => {
    setIPanelOpen(props.customer !== undefined);
  }, [props.customer]);

  const onCloseDeleteCustomerPanel = () => {
    setIPanelOpen(false);
    if (props.onClose) props.onClose();
  };

  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  return (
    <>
      <RigthPanel
        header="Delete Customer"
        isOpen={isPanelOpen}
        dismissPanel={onCloseDeleteCustomerPanel}
        childComponent={DeleteCustomerForm}
        childProps={{
          customer: props.customer,
          onClose: () => onCloseDeleteCustomerPanel(),
          onDelete: (customer: Customer) => {
            props.onDelete(customer);
            onCloseDeleteCustomerPanel();
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default DeleteCustomer;
